<template>
  <div class="device-selection-container">
    <div class="search-filters">
      <el-row :gutter="10">
        <el-col :span="24">
          <span class="form-label">物理机编号</span>
          <el-input
            v-model="cloudMachineNumber"
            type="textarea"
            :autosize="{ minRows: 1, maxRows: 4 }"
            placeholder="支持输入多个编号，逗号/空格/换行分隔"
            class="filter-input"
          />
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <span class="form-label">机房名称</span>
          <el-select v-model="machineRoom" multiple filterable placeholder="请选择机房名称" class="filter-input" clearable>
            <el-option v-for="item in machineRoomList" :key="item" :label="item" :value="item" />
          </el-select>
        </el-col>
        <el-col :span="24">
          <span class="form-label">物理机IP</span>
          <el-select v-model="physicalMachineIp" multiple filterable  
          collapse-tags collapse-tags-tooltip :max-collapse-tags="3"  placeholder="请选择物理机IP" class="filter-input" clearable>
            <el-option v-for="item in physicalMachineIpList" :key="item" :label="item" :value="item" />
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10">
       <el-col :span="24" style="display:flex;justify-content: center;margin-top: 20px;z-index: 100;">
          <el-button size="small" @click="clearSelection">重置</el-button>
          <el-button type="primary" size="small" @click="getDeviceList">搜索</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="device-list-container">
    <div class="title">
      <span class="device-title">设备列表</span>
      <div class="title-actions">
        <el-button size="small" @click="toggleSelectAll">
          {{ isAllSelected ? '取消全选' : '全选' }}
        </el-button>
        <el-select v-model="selectedDevice" style="width:100px;" filterable allow-create size="small" 
        placeholder="自定义数量" clearable @change="changeDefineChecked">
          <el-option v-for="item in numList" :key="item" :label="item" :value="item" />
        </el-select>
        <el-button v-show="!isExpandAll" type="primary" size="small" @click="expandAll">展开全部</el-button>
        <el-button v-show="isExpandAll" type="primary" size="small" @click="collapseAll">收起全部</el-button>
        <span class="selected-count">已选中：{{ totalSelectedDevices|| 0 }}台</span>
      </div>
    </div>
    <div class="content-area" v-loading="loading">
      <div class="tree-container">
        <el-tree
          ref="treeRef"
          :data="treeData"
          :props="treeProps"
          node-key="cloudMachineNumber"
          :key="treeKey"
          show-checkbox
          :default-expand-all="isExpandAll"
          :default-checked-keys="defaultCheckedKeys"
          @check="handleCheck"
        >
          <template #default="{ node, data }">
            <span>
              <template v-if="node.level === 1">
                <i class="el-icon-folder"></i>
                物理机IP：{{ data.physicalMachineIp }} - {{data.cloudMachinesOpenNum}}开 ({{ data.cloudDeviceDistributionList.length||0 }}台)
              </template>
              <template v-else>
                <i class="el-icon-cpu"></i>
                设备物理编码：{{ data.cloudMachineNumber }}, 机房名称:{{ data.machineRoom }}
              </template>
            </span>
          </template>
        </el-tree>
      </div>
    </div>
    </div>
  </div>
</template>
  <script setup>
import { ref, defineProps, defineExpose, defineEmits, computed, onMounted, watch, nextTick } from "vue";
import request from "@/utils/request.ts";
const emit = defineEmits(["update:modelValue"]);
const props = defineProps({
  // v-model 绑定值 (Base64字符串)
  modelValue: {
    type: String,
    default: ""
  },
  categoryId: {
    type: String,
    default: ""
  }
});
const machineRoom = ref("");
const cloudMachineName = ref("");
const cloudMachineNumber = ref("");
const physicalMachineIp = ref("");
const treeRef = ref(null);
const checkedKeys = ref([]);
const treeData = ref([]);
const machineRoomList = ref([]);
const physicalMachineIpList = ref([]);
const defaultCheckedKeys = ref([]);
const loading = ref(false);
const isAllSelected = ref(false);
const isExpandAll = ref(true);
const treeKey = ref(0);
const numList = ref(['10','30','50','100','200','500']);

// 组件挂载时获取机房名称和物理机IP列表
onMounted(() => {
  getMachineRoomAndphysicalMachineIpList();
});

// Tree configuration
const treeProps = {
  children: "cloudDeviceDistributionList",
  label: "name",
  disabled: data => data.disabled || false
};

// Computed properties
const totalSelectedDevices = computed(() => {
  return checkedKeys.value.filter(
    ele => !treeData.value.some(item => item.cloudMachineNumber == ele)
  ).length;
});

// 处理选中事件
const handleCheck = (data, checked) => {
  // Update checked keys
  checkedKeys.value = treeRef.value.getCheckedKeys();
  const selectedDevice = checkedKeys.value.filter(
    ele => !treeData.value.some(item => item.cloudMachineNumber == ele)
  );
  emit("update:modelValue", selectedDevice);
  
  // 更新全选状态
  updateAllSelectedStatus();
};

// 更新全选状态
const updateAllSelectedStatus = () => {
  if (treeData.value.length === 0) {
    isAllSelected.value = false;
    return;
  }
  
  // 获取所有可选设备节点数量
  let totalDevices = 0;
  let selectedDevices = 0;
  
  treeData.value.forEach(physicalMachine => {
    if (physicalMachine.cloudDeviceDistributionList && physicalMachine.cloudDeviceDistributionList.length > 0) {
      physicalMachine.cloudDeviceDistributionList.forEach(device => {
        if (!device.disabled) {
          totalDevices++;
          if (checkedKeys.value.includes(device.cloudMachineNumber)) {
            selectedDevices++;
          }
        }
      });
    }
  });
  
  isAllSelected.value = totalDevices > 0 && selectedDevices === totalDevices;
};

// 清空选择
const clearSelection = () => {
  machineRoom.value = "";
  cloudMachineName.value = "";
  physicalMachineIp.value = "";
  cloudMachineNumber.value = "";
  checkedKeys.value = [];
  defaultCheckedKeys.value = [];
  getDeviceList();
  emit("update:modelValue", []);
};

// 解析 Base64 字符串并设置默认选中项
const setDefaultCheckedKeys = (base64String) => {
  try {
    if (typeof base64String === 'string' && base64String) {
      // 处理 Base64 解码
      const decodedString = atob(base64String);
      const parsedData = JSON.parse(decodedString);
      
      // 确保解析结果是数组
      if (Array.isArray(parsedData)) {
        defaultCheckedKeys.value = parsedData;
        // 如果 treeData 已加载完成，直接设置选中状态
        if (treeData.value.length > 0 && treeRef.value) {
          nextTick(() => {
            setTreeCheckedState(parsedData);
          });
        }
      } else {
        console.warn('解析的 Base64 数据不是数组');
        defaultCheckedKeys.value = [];
      }
    } else {
      // 如果传入的不是字符串或为空，直接使用原值
      defaultCheckedKeys.value = Array.isArray(base64String) ? base64String : [];
    }
  } catch (error) {
    console.error('解析 Base64 字符串失败:', error);
    // 解析失败时使用空数组作为默认值
    defaultCheckedKeys.value = [];
  }finally {
    if ( defaultCheckedKeys.value.length ==0) {
       checkedKeys.value = [];
    }
  }
};

// 手动设置树的选中状态
const setTreeCheckedState = (keys) => {
  if (treeRef.value && Array.isArray(keys)) {
    // 先清空所有选中状态
    treeRef.value.setCheckedKeys([]);
    // 然后设置新的选中状态
    treeRef.value.setCheckedKeys(keys);
    // 更新内部 checkedKeys 状态
    checkedKeys.value = keys;
  }
};

// 物理机编号支持多编号输入（逗号/空格/换行分隔），查询时合并为逗号分隔字符串
const normalizeNumbers = () =>
  cloudMachineNumber.value
    .split(/[\s,，]+/)
    .filter(Boolean)
    .join(",");

// 获取设备列表
const getDeviceList = () => {
  loading.value = true;
  request
    .post("/goods/goodsEquipmentDistribution/selectByDeviceIdGroup", {
      machineRoom: (machineRoom.value||[]).join(','),
      physicalMachineIp: (physicalMachineIp.value||[]).join(','),
      categoryId: props.categoryId,
      cloudMachineNumber: normalizeNumbers()
    })
    .then(res => {
      if (res.code == 200) {
        treeData.value = (res.data || []).sort((a, b) => a.physicalMachineIp.localeCompare(b.physicalMachineIp,undefined,{
          numeric: true,
          sensitivity: 'base', // 忽略大小写和重音符号差异
        }));
      } else {
        treeData.value = [];
      }
    }).finally(() => {
      // 确保数据加载完成后再设置默认值
      if (props.modelValue) {
        setDefaultCheckedKeys(props.modelValue);
      } else {
        defaultCheckedKeys.value = [];
      }

      if(machineRoom.value.length==0&&physicalMachineIp.value.length==0){
           physicalMachineIpList.value = (treeData.value || []).map(item=>item.physicalMachineIp).sort((a, b) => a.localeCompare(b,undefined,{
          numeric: true,
          sensitivity: 'base', // 忽略大小写和重音符号差异
        }));
      }
      loading.value = false;
      if(treeData.value.length&&treeData.value[0].cloudMachinesOpenNum==1){
        isExpandAll.value = false;
        treeKey.value++;
      }      
      // 数据加载完成后更新全选状态
      nextTick(() => {
        updateAllSelectedStatus();
      });
    });
};

// 获取机房名称和物理机IP列表
const getMachineRoomAndphysicalMachineIpList = () => {
  request
    .post("/goods/goodsEquipmentDistribution/getDropdownList")
    .then(res => {
      if (res.code == 200&&res.data) {
        machineRoomList.value = res.data?.machineRoomList || [];
      }
    }).finally(() => {
      // 确保基础数据加载完成后再获取设备列表
      getDeviceList();
      
    });
}

// 切换全选状态
const toggleSelectAll = () => {
  if (treeRef.value && treeData.value.length > 0) {
    // 获取所有设备节点的key（只选择叶子节点）
    const allDeviceKeys = [];
    treeData.value.forEach(physicalMachine => {
      if (physicalMachine.cloudDeviceDistributionList && physicalMachine.cloudDeviceDistributionList.length > 0) {
        physicalMachine.cloudDeviceDistributionList.forEach(device => {
          if (!device.disabled) {
            allDeviceKeys.push(device.cloudMachineNumber);
          }
        });
      }
    });
    
    if (isAllSelected.value) {
      // 取消全选
      treeRef.value.setCheckedKeys([]);
      checkedKeys.value = [];
      emit("update:modelValue", []);
      isAllSelected.value = false;
    } else {
      // 设置全选
      treeRef.value.setCheckedKeys(allDeviceKeys);
      checkedKeys.value = allDeviceKeys;
      emit("update:modelValue", allDeviceKeys);
      isAllSelected.value = true;
    }
  }
};

// 展开全部
const expandAll = () => {
  isExpandAll.value = true;
  treeKey.value++;
};

// 收起全部
const collapseAll = () => {
 isExpandAll.value = false;
  treeKey.value++;
};

// 监听 modelValue 变化
watch(() => props.modelValue, (newVal) => {
  if (newVal) {
    setDefaultCheckedKeys(newVal);
  }
}, { immediate: true });


const selectedDevice = ref(null);
const changeDefineChecked = (val) => {
 if (!val || !treeRef.value || treeData.value.length === 0) {
   treeRef.value.setCheckedKeys([]);
   checkedKeys.value = [];
   emit("update:modelValue", []);
    return;
  }
  
  const count = parseInt(val);
  if (isNaN(count) || count <= 0) {
    return;
  }
  
  // 获取所有可选的设备节点（叶子节点，非禁用）
  const allAvailableDevices = [];
  treeData.value.forEach(physicalMachine => {
    if (physicalMachine.cloudDeviceDistributionList && physicalMachine.cloudDeviceDistributionList.length > 0) {
      physicalMachine.cloudDeviceDistributionList.forEach(device => {
        if (!device.disabled) {
          allAvailableDevices.push(device.cloudMachineNumber);
        }
      });
    }
  });
  
  // 取前 count 个设备
  const selectedKeys = allAvailableDevices.slice(0, count);
  
  // 设置选中状态
  treeRef.value.setCheckedKeys(selectedKeys);
  checkedKeys.value = selectedKeys;
  emit("update:modelValue", selectedKeys);
  
  // 更新全选状态
  updateAllSelectedStatus();
}

defineExpose({ getDeviceList, expandAll, collapseAll });
</script>

<style lang="scss" scoped>
// 主题颜色变量
$primary-color: #409eff;
$success-color: #67c23a;
$border-color: #ebeef5;
$bg-color: #f5f7fa;
$text-color: #303133;
$text-color-secondary: #606266;

.device-selection-container {
  padding: 20px;
  width: 100%;
  flex: 1;
  margin: 0 auto;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: $text-color;
  display: flex;
}

.search-filters {
  width: 240px;
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  margin-right: 15px;
  transition: box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 10px;
  &:hover {
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
  }
}

.el-col {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  
  &:last-child {
    margin-bottom: 0;
    justify-content: flex-end;
  }
}

.form-label {
  width: 120px;
  line-height: 32px;
  display: inline-block;
  font-weight: 500;
  color: $text-color;
  margin-right: 12px;
}

.filter-input {
  flex: 1;
  min-width: 200px;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid $border-color;
}

.title-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.device-title {
  display: inline-block;
  padding-left: 12px;
  position: relative;
  font-size: 16px;
  width: 100px;
  font-weight: 600;
  color: $text-color;
  
  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 16px;
    background: $primary-color;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 2px;
  }
}
.device-list-container {
  flex: 1;
}

.selected-count {
  color: $primary-color;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.content-area {
  max-height: 45vh;
  margin-bottom: 20px;
  border: 1px solid $border-color;
  border-radius: 8px;
  padding: 16px;
  overflow: auto;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.tree-container {
  height: 100%;
  overflow: auto;
}

.el-tree {
  background: transparent;
}

.el-tree-node {
  &__content {
    height: 40px;
    line-height: 40px;
    transition: background-color 0.2s ease;
    
    &:hover {
      background-color: rgba(64, 158, 255, 0.05);
    }
  }
  
  &:nth-child(odd) .el-tree-node__content {
    background-color: rgba(0, 0, 0, 0.01);
  }
}

.el-icon-folder {
  color: $primary-color;
  margin-right: 8px;
  font-size: 16px;
}

.el-icon-cpu {
  color: $success-color;
  margin-right: 8px;
  font-size: 14px;
}

// 按钮样式优化
.el-button {
  border-radius: 4px;
  transition: all 0.3s ease;
  
  &--primary {
    background-color: $primary-color;
    border-color: $primary-color;
    
    &:hover,
    &:focus {
      background-color: lighten($primary-color, 5%);
      border-color: lighten($primary-color, 5%);
    }
  }
  
  &--small {
    padding: 8px 16px;
    font-size: 14px;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .device-selection-container {
    padding: 10px;
  }
  
  .form-label {
    width: 80px;
    font-size: 14px;
  }
  
  .filter-input {
    min-width: 150px;
  }
  
  .title {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .title-actions {
    width: 100%;
    justify-content: flex-end;
  }
  
  .selected-count {
    margin-left: 10px;
  }
}
</style>